export const VOLUUM_INTEGRATION_URL = 'https://kiliticsmearter.com/postback?'
export const VOLUUM_CID_COOKIE = 'voluumCidCookie'
